// For form elements/components with dynamic behaviours
document.addEventListener('DOMContentLoaded', () => {
  // [CUSTOMER LEVEL] Distance to Work checkbox disable dynamically
  const allowCustomerCheckbox = document.getElementById("customer_check_in_feature");
  const captureCustomerCheckbox = document.getElementById("customer_distance_to_work_feature");

  if (!allowCustomerCheckbox || !captureCustomerCheckbox) return;

  const toggleCustomerCapture = () => {
    captureCustomerCheckbox.disabled = !allowCustomerCheckbox.checked;
    if (captureCustomerCheckbox.disabled) {
      captureCustomerCheckbox.checked = false;
    }
  };

  toggleCustomerCapture();
  allowCustomerCheckbox.addEventListener("change", toggleCustomerCapture);


  // [SITE LEVEL] Distance to Work checkbox disable dynamically
  const allowSiteCheckbox = document.getElementById("site_allow_operative_check_in");
  const captureSiteCheckbox = document.getElementById("site_distance_to_work");

  if (!allowSiteCheckbox || !captureSiteCheckbox) return;

  const toggleSiteCapture = () => {
    captureSiteCheckbox.disabled = !allowSiteCheckbox.checked;
    if (captureSiteCheckbox.disabled) {
      captureSiteCheckbox.checked = false;
    }
  };

  toggleSiteCapture();
  allowSiteCheckbox.addEventListener("change", toggleSiteCapture);
});


document.addEventListener("turbolinks:load", () => {
  const path = window.location.pathname;
  const isInductionPage = path === '/inductions/new' || /^\/inductions\/[0-9a-fA-F-]+\/edit$/.test(path);
  if(isInductionPage) {
    // Character counter for Site Rules
    const siteRules = document.getElementById("induction_delivery_rule_attributes_rules");
    const rulesCounter = document.getElementById("induction_rules_counter");

    siteRules.addEventListener("input", () => {
      rulesCounter.textContent = `Character count: ${siteRules.value.length} / 1000`;
    });

    const hideFields = () => {
      document.querySelectorAll('.hideField').forEach(fieldsToBeHidden => {
        fieldsToBeHidden.style.display = 'none';
      });
    };


    // Hiding fields depending on selected induction type
    const inductionTypeVideo = document.getElementById("induction_kind_video");
    const inductionTypeForm = document.getElementById("induction_kind_form");
    const inductionTypeRules = document.getElementById("induction_kind_rules");

    const inductionExpiry = document.querySelector('.expiry_toggle');
    const inductionApproval = document.querySelector('.approval_toggle');

    const displayFieldNew = () => {
      var inductionType;
      var expiryDisplay;
      var approvalDisplay;

      if (inductionTypeVideo.checked) {
        inductionType = 'videoQuiz';
        inductionExpiry.style.display = 'flex';
        inductionApproval.style.display = 'none';
      } else if (inductionTypeForm.checked) {
        inductionType = 'questionSet';
        inductionExpiry.style.display = 'flex';
        inductionApproval.style.display = 'flex';
      } else if (inductionTypeRules.checked) {
        inductionType = 'deliveryRules';
        inductionExpiry.style.display = 'none';
        inductionApproval.style.display = 'none';
      }

      hideFields();

      document.querySelectorAll('.' + inductionType).forEach(fieldsToBeDisplayed => {
        fieldsToBeDisplayed.style.display = 'flex';
      });

      if(inductionType == 'deliveryRules'){
        document.getElementById("induction_expires").checked = false;
        document.getElementById("induction_requires_approval").checked = false;
      }
    };

    const displayFieldEdit = () => {
      if(window.getComputedStyle(siteRules).display !== 'none'){
        hideFields();
        document.querySelectorAll('.deliveryRules').forEach(fieldsToBeDisplayed => {
          fieldsToBeDisplayed.style.display = 'flex';
        });
      }
    };

    if(path.includes('/inductions') && path.includes('/new')) {
      inductionTypeVideo.addEventListener("change", displayFieldNew);
      inductionTypeForm.addEventListener("change", displayFieldNew);
      inductionTypeRules.addEventListener("change", displayFieldNew);
      displayFieldNew();
    }

    if(path.includes('/inductions') && path.includes('/edit')) {
      displayFieldEdit();
    }
  }

  
});
